var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.actionClass,style:({
  backgroundImage: _vm.$vssWidth > 700 ? ("url('" + _vm.image + "')") : 'none',
  backgroundPositionX: _vm.backgroundPositionX,
  backgroundPositionY: _vm.backgroundPositionY
})},[_c('div',{staticClass:"page-content action-text"},[_vm._t("default")],2),_c('div',{staticClass:"dummy",style:({backgroundImage: ("url('" + _vm.image + "')")})})])}
var staticRenderFns = []

export { render, staticRenderFns }